package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2025_02_22_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes who have learned that Do’shara has been impersonating Samuel Thardos, Duke of Brij. They found the real Duke of Brij’s corpse in the Thardos family ruins’ dungeon along with the remains of Evan and Rachel, the lost couple from Well’s Bounty. This chapter of the heroes’ story has nearly concluded, but they can’t move on until they solve one remaining mystery — what happened to Alexander the cow?")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Tuesday sings a song about Alexander the cow. Goram reluctantly agrees to head out to Fool’s Oasis even though he would prefer to focus on the mission, the preservation of life and freedom on Veldekar. On the way, the heroes see more broken traps like the ones they saw the previous day, and they notice a lot of wildlife heading towards the ruins — plenty of dragon to eat for all animals big or small.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("During the night, Goram hears a large flying creature to the west.")
    }
}
